import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-steel/30 bg-navy-950 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-153" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-154" data-mp="2vowj0erbpuyb">
        <div className="text-center" data-id="element-155" data-mp="39hmbn21cxy4e">
          <SectionHeading id="problem-title" data-id="element-156" data-mp="39gkzsvcip7lm">Does This Sound <span className="text-copper" data-id="element-157" data-mp="35gap55ds5t0f">Familiar?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-steel-light" data-id="element-158" data-mp="35idgptukzu79">
            You work with switchboards, MCCs and switchgear in industrial plants, utilities or electrical maintenance, but the
            distribution system still feels like a set of separate pieces. When someone talks about single-line diagrams,
            protection coordination, MV interruption technologies, testing or arc flash awareness, you can&apos;t connect all
            the pieces with confidence.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-steel/70 bg-navy-900 p-6 shadow-lg shadow-black/30 sm:p-8" data-id="element-159" data-mp="obye6c4574m3">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-extrabold uppercase text-white" data-id="element-160" data-mp="123d0artcjlxd">
            <AlertTriangleIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-161" data-mp="174slcjvixsfr" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-162" data-mp="1g3dyu0m52h9o">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-steel-light" data-id="element-163" data-mp="1g2kzvltf8w23">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-copper" aria-hidden="true" data-id="element-164" data-mp="3duyro2zi80vm" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-165" data-mp="p11zu5rl0tm4">
          <p className="mx-auto max-w-2xl text-lg font-bold text-white" data-id="element-166" data-mp="k15v24b28y5i">
            You don&apos;t need more scattered information.
          </p>
          <p className="mt-3 text-2xl font-extrabold uppercase tracking-tight text-gold sm:text-3xl" data-id="element-167" data-mp="y1qdv0gz6tz0">You need one organized system.</p>
        </div>
      </div>
    </section>;
}